import { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";

export default function SignIn() {
  const [details, setDetails] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
    // console.log("Change:", e.target.name, e.target.value); // Debug
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!details.email || !details.password) {
      toast.error("Email and Password is required");
      return;
    }
    const loadingToast = toast.loading("Please wait...");
    try {
      const formData = new FormData();
      formData.append("email", details.email);
      formData.append("password", details.password);

      const response = await axios.post(
        `${API_BASE_URL}/api/admin/admin-login`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      // console.log(response);
      if (response?.data?.statusCode === 200) {
        const token = response.data.result.token;
        localStorage.setItem("token", token);
        localStorage.setItem("AdminId", response.data.result._id);
        toast.success("Login successful");
        navigate("/admin/default");
      } else {
        toast.error(response.data.message || "Invalid Email or Password");
      }
    } catch (error) {
      toast.error("Login failed. Please try again.");
      // console.error(error);
    } finally {
      toast.dismiss(loadingToast);
    }
  };

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email and password to sign in!
        </p>
        <form  onSubmit={handleLogin}>
          <label className="dark:text-white">Email*</label>
          <input
            type="text"
            name="email"
            value={details.email}
            onChange={handleChange}
            placeholder="Email"
            // className='w-full border-2 border-gray-400 rounded-full bg-black p-3 mt-2 bg-transparent text-black focus:outline-none'
            className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white"
          />
          <label className="dark:text-white">Password*</label>
          <input
            type="password"
            name="password"
            value={details.password}
            onChange={handleChange}
            placeholder="Password"
            className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white"

          />
          <div className=" mt- mb-4 flex items-center justify-between px-2">
            <Link
              to="/auth/forgot-password"
              className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            >
              Forgot password?
            </Link>
          </div>
          <button
            type="submit"
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
